import { Info } from 'lucide-react';
import type { ReactElement } from 'react';

interface EditorHintBarProps {
  readonly message: string;
}

/** 도구 줄 바로 아래 얇은 안내 한 줄 — 지금 할 수 있는 일을 알린다. 넘치면 말줄임한다. */
export const EditorHintBar = ({ message }: EditorHintBarProps): ReactElement => (
  <p
    role="status"
    data-testid="editor-hint"
    className="flex h-8 shrink-0 items-center gap-1.5 border-b border-foreground/10 bg-muted/40 px-3 text-xs text-muted-foreground"
  >
    <Info aria-hidden className="size-3.5 shrink-0" strokeWidth={1.5} />
    <span className="truncate">{message}</span>
  </p>
);
